<template>
    <vue-select
        v-bind="$attrs"
        v-on="$listeners"
        :options="options"
        ref="select"
    >
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök på leveranser</em>
        </template>
        <template #option="{name, description}">
            <div class="auto-hit">
                <div>
                    <strong>{{ name }}</strong>
                </div>
                <div><i>{{ description }}</i></div>
            </div>
        </template>
    </vue-select>
</template>
<script>
import VueSelect from '@components/Wrappers/VueSelect';
import apiClient from '@services/ApiClient';

export default {
    props: {
        defaultId: {
            default: null,
        },
    },
    components: {
        VueSelect,
    },
    data() {
        return {
            options: [],
        };
    },
    async created() {
        await apiClient.get('/vue/stocktaking/locations').then((res) => {
            this.options = res.data.map((item) => {
                // eslint-disable-next-line no-param-reassign
                item.label = item.name;
                return item;
            });
        });
    },
};
</script>
